import { action, computed, observable } from 'mobx';
import { isGranted } from '../lib/abpUtility';
import { LectoTypeStatus, TechnologyQuotationStatus } from '../services/serviceProxy';

// inventory state
//      te state
//      dq state

enum InvotorySteps {
    unknown = -1,
    ProductPackSelection = 0,
    BasicMotorSelection = 1,
    VCSelection = 2,
    ListPriceMatching = 3,
    Quotation = 4
}

class btnState {
    @observable isShow: boolean;
    @observable isClickable: boolean;
    @observable btnText: string;
}

class InventoryStatusStore {
    @observable invState?: LectoTypeStatus;
    @observable teState?: TechnologyQuotationStatus;
    @observable pmsProjectType?: number; // 0: 非一次性项目 1: 一次性项目
    @observable pmsDqState?: boolean = false;// 一次性项目的国产报价状态
    @observable jinLectoType: boolean = false; // 是否是境界选型
    @observable dqState?: TechnologyQuotationStatus;
    @observable currentStep: number = -1;
    @observable inventoryHasIssue: boolean = false;
    @observable inventoryDqHasIssue: boolean = false;
    @observable inventoryTeHasIssue: boolean = false;
    @observable invClientId: string;
    @observable saleId: string;

    @observable globalBtnState: boolean = true;

    @observable prevBtnState: btnState = new btnState();
    @observable nextBtnState: btnState = new btnState();
    @observable completeBtnState: btnState = new btnState();
    @observable teBtnState: btnState = new btnState();
    @observable dqBtnState: btnState = new btnState();
    @observable needHelpBtnState: btnState = new btnState();
    @observable gcsCompleteBtnState: btnState = new btnState();

    constructor() {
        this.currentStep = InvotorySteps.unknown;
    }

    prevStateUpdate = () => {
        var isShow = true;
        var isClickable = true;
        var btnText = "上一步";
        // 第一页不显示上一步
        if (this.currentStep === InvotorySteps.ProductPackSelection
            || this.currentStep === InvotorySteps.unknown) {
            isShow = isShow && false;
        }
        // 报价页不显示上一步
        if (this.currentStep === InvotorySteps.Quotation) {
            isShow = isShow && false;
        }

        // 审核中上一步不能点
        if (this.teState === TechnologyQuotationStatus.WaitToExamine ||
            this.dqState === TechnologyQuotationStatus.WaitToExamine) {
            isClickable = isClickable && false;
        }

        //报价或者协议有一个成功，都不能点击上一步
        if (this.teState === TechnologyQuotationStatus.ExamineSuccess ||
            this.dqState === TechnologyQuotationStatus.ExamineSuccess) {
            isClickable = isClickable && false;
        }

        // 协议通过，报价驳回，上一步不能点
        if (this.teState === TechnologyQuotationStatus.ExamineSuccess &&
            this.dqState === TechnologyQuotationStatus.Rejected) {
            isClickable = isClickable && false;
        }

        this.prevBtnState.isShow = isShow && this.globalBtnState;
        this.prevBtnState.isClickable = isClickable;
        this.prevBtnState.btnText = btnText;
    }

    nextStateUpdate = () => {
        var isShow = true;
        var isClickable = true;
        var btnText = "下一步";

        // 报价页不显示下一步
        if (this.currentStep === InvotorySteps.Quotation) {
            isShow = isShow && false;
        }

        if (this.currentStep === InvotorySteps.ListPriceMatching) {
            btnText = "报价";
            if (isGranted("Role.ProductManager") || this.jinLectoType) {
                btnText = "完成";
            }
            if (this.invState === LectoTypeStatus.GCSHelping || isGranted("Role.ProductManager")) {
                // 2,3,7 去掉最后一步
                // 2,3 显示国产报价和技术协议按钮
                if (this.pmsDqState && this.pmsProjectType === 1) {
                    isShow = true;
                } else {
                    isShow = isShow && false;
                }
            }
        }

        // 审核中下一步不能点
        if (this.teState === TechnologyQuotationStatus.WaitToExamine ||
            this.dqState === TechnologyQuotationStatus.WaitToExamine) {
            isClickable = isClickable && false;
        }

        if (this.currentStep == InvotorySteps.ListPriceMatching) {
            isShow = true;
            isClickable = isClickable && this.inventoryHasIssue;
        }
        //如果是处于面价匹配状态，并且是gcs，并且选型是进行中状态、GCS帮助中
        if (this.currentStep === InvotorySteps.ListPriceMatching && (isGranted('Role.GCS') || isGranted('Role.SuperGCS')) && (this.invState == LectoTypeStatus.Conducting || this.invState == LectoTypeStatus.GCSHelping)) {
            isShow = isShow && false;
        }
        if (
            this.jinLectoType &&
            (this.dqState === TechnologyQuotationStatus.ExamineSuccess && this.teState === TechnologyQuotationStatus.ExamineSuccess)
        ) {
            isShow = true;
        }
        // PM没有请求帮助不可以完成
        if (this.currentStep === InvotorySteps.ListPriceMatching && !this.pmsDqState && this.pmsProjectType === 1) {
            isClickable = isClickable && false;
        }
        this.nextBtnState.isShow = isShow && this.globalBtnState;
        this.nextBtnState.isClickable = isClickable;
        this.nextBtnState.btnText = btnText;
        // this.nextBtnState = {...this.nextBtnState};
        //海外技术支持角色，面价匹配不显示报价按钮
        if (this.currentStep === InvotorySteps.ListPriceMatching && isGranted("Role.GlobalTechnicalSupport")){
           this.nextBtnState.isShow = false;
        }
    }

    completeStateUpdate = () => {
        var isShow = false;
        var isClickable = false;
        var btnText = "完成";

        //报价和协议都没开始
        //国产报价完成，协议没开始
        //两个都完成
        if ((this.dqState === TechnologyQuotationStatus.UnKnow && this.teState === TechnologyQuotationStatus.UnKnow) ||
            (this.dqState === TechnologyQuotationStatus.ExamineSuccess && this.teState === TechnologyQuotationStatus.UnKnow) ||
            (this.dqState === TechnologyQuotationStatus.ExamineSuccess && this.teState === TechnologyQuotationStatus.ExamineSuccess)
        ) {
            if (this.pmsProjectType === 1 && this.dqState !== TechnologyQuotationStatus.ExamineSuccess) {
                isClickable = false;
            } else {
                isClickable = true;
            }
        }
        //如果是gcs角色，并且在GCS帮助中状态，则显示
        if ((isGranted('Role.GCS') || isGranted('Role.SuperGCS')) && this.invState === LectoTypeStatus.GCSHelping) {
            isShow = true;
        }
        //如果是sale角色，并且在sale帮助中状态，则显示
        if (isGranted('Role.Sales') && this.invState === LectoTypeStatus.SaleHelping) {
            isShow = true;
        }
        //如果是sale角色，并且在销售帮助申请折扣中、销售帮助申请折扣审批通过、销售帮助申请折扣审批拒绝。则显示
        // update by wanglonglong 2021-09-15 需求变更,仅当Precal特价申请审核后才显示"完成"按钮
        if (isGranted('Role.Sales') && (this.invState === LectoTypeStatus.销售帮助申请折扣审批通过
            || this.invState === LectoTypeStatus.销售帮助申请折扣审批拒绝)) {
            isShow = true;
        }
        isClickable = isClickable && this.inventoryHasIssue;
        this.completeBtnState.isClickable = isClickable;

        this.completeBtnState.isShow = isShow && this.globalBtnState;
        this.completeBtnState.btnText = btnText;
    }

    needHelpbtnStateUpdate = () => {
        var isShow = false;
        var isClickable = false;
        var btnText = "请求协助";
        const invState=this.invState;
        const isCP = isGranted('Role.CP');
        const isSales = isGranted('Role.Sales');
        const commerce = isGranted("Role.SuperCommerce") || isGranted("Role.Commerce") || isGranted('Role.CommerceAndNonSO') || isGranted("Role.SuperCommercePlus") ;        
        
        //如果是cp角色，并且在进行中状态或者报价状态，则显示
        if (isCP && (invState === LectoTypeStatus.Conducting)) {
            isShow = true;
        }
        //如果是sale角色，并且在进行中状态，并且不处于报价步骤,显示
        if (isSales && invState === LectoTypeStatus.Conducting && this.currentStep != InvotorySteps.Quotation) {
            isShow = true;
        }
        //如果是sale角色，并且在销售协助中状态，并且不处于报价步骤,显示
        if (isSales && invState === LectoTypeStatus.SaleHelping && this.currentStep != InvotorySteps.Quotation) {
            isShow = true;
        }
        //如果是cp角色，并且在报价中状态，并且是cpsale，则不显示
        if (isCP && this.currentStep === InvotorySteps.Quotation && this.invClientId.substring(this.invClientId.length - 2) === '-1') {
            isShow = false;
        }
        // 当用户为CP时,验证用户的责任销售是否为空,为空时不显示请求协助按钮
        if (isCP && !this.saleId) {
            isShow = false;
        }
        if (commerce && invState === LectoTypeStatus.Conducting) {
            isShow = true
        }
        if (isGranted('Role.ProductManager')) {
            isShow = true;
        }
        if (this.invState === LectoTypeStatus.NeedGCSHelp) {
            isClickable = true;
        }
        this.needHelpBtnState.isClickable = isClickable;
        this.needHelpBtnState.isShow = isShow && this.globalBtnState;
        this.needHelpBtnState.btnText = btnText;
    }

    gcsCompleteBtnStateUpdate = () => {
        var isShow = false;
        var isClickable = true;
        var btnText = "转交选型";

        //如果gcs，并且是进行中状态,并且国产报价和技术协议都审核通过
        //报价和协议都没开始
        //国产报价完成，协议没开始
        //两个都完成
        if ((isGranted('Role.GCS') || isGranted('Role.SuperGCS')) && this.invState === LectoTypeStatus.Conducting &&
            ((this.dqState === TechnologyQuotationStatus.UnKnow && this.teState === TechnologyQuotationStatus.UnKnow) ||
                (this.dqState === TechnologyQuotationStatus.ExamineSuccess && this.teState === TechnologyQuotationStatus.UnKnow) ||
                (this.dqState === TechnologyQuotationStatus.ExamineSuccess && this.teState === TechnologyQuotationStatus.ExamineSuccess))
        ) {
            isShow = true;
        }

        isClickable = isClickable && this.inventoryHasIssue;

        this.gcsCompleteBtnState.isShow = isShow && this.globalBtnState;
        this.gcsCompleteBtnState.isClickable = isClickable;
        this.gcsCompleteBtnState.btnText = btnText;
    }

    /*
    WaitToExamine = 0,
    Rejected = 1,
    ExamineSuccess = 2,
    Completed = 3,
    Disable = 4,
    UnKnow = -1,
    */
    teStateUpdate = () => {
        var isShow = true;
        var isClickable = true;
        var btnText = "生成技术协议";

        // 编辑中
        if (this.teState === TechnologyQuotationStatus.Draft) {
            btnText = "技术协议编辑中";
        } else
            // 审核中
            if (this.teState === TechnologyQuotationStatus.WaitToExamine) {
                isClickable = isClickable && false;
                btnText = "技术协议审核中";
            } else

                // 驳回
                if (this.teState === TechnologyQuotationStatus.Rejected) {
                    btnText = "技术协议驳回";
                } else

                    // 审核通过
                    if (this.teState === TechnologyQuotationStatus.ExamineSuccess) {
                        isClickable = isClickable && false;
                        btnText = "技术协议审核通过";
                    } else

                        // 生效
                        if (this.teState === TechnologyQuotationStatus.Completed) {
                            isClickable = isClickable && false;
                            btnText = "技术协议已生效";
                        }
                        else

                            // 禁用
                            if (this.teState === TechnologyQuotationStatus.Disable) {
                                isClickable = isClickable && false;
                                btnText = "技术协议已禁用";
                            }

        if (!isGranted("Role.GCS") && !isGranted("Role.SuperGCS")) {
            isShow = isShow && false;
        }

        if (this.inventoryTeHasIssue) {
            isShow = isShow && true;
        } else {
            isShow = isShow && false;
        }

        this.teBtnState.isShow = isShow && this.globalBtnState;
        this.teBtnState.isClickable = isClickable;
        this.teBtnState.btnText = btnText;
    }

    dqStateUpdate = () => {
        var isShow = true;
        var isClickable = true;
        var btnText = "生成国产报价";
        if (this.pmsProjectType === 1) {
            btnText = "一次性项目国产报价"
        }
        // 编辑中
        if (this.dqState === TechnologyQuotationStatus.Draft) {
            if (this.pmsProjectType === 1) {
                btnText = "一次性国产报价编辑中";
            } else {
                btnText = "国产报价编辑中";
            }
        } else
            // 审核中
            if (this.dqState === TechnologyQuotationStatus.WaitToExamine) {
                isClickable = isClickable && false;
                if (this.pmsProjectType === 1) {
                    btnText = "一次性国产报价审核中";
                } else {
                    btnText = "国产报价审核中";
                }
            } else

                // 驳回
                if (this.dqState === TechnologyQuotationStatus.Rejected) {
                    if (this.pmsProjectType === 1) {
                        btnText = "一次性国产报价驳回";
                    } else {
                        btnText = "国产报价驳回";
                    }
                } else
                    // 审核通过
                    if (this.dqState === TechnologyQuotationStatus.ExamineSuccess) {
                        isClickable = isClickable && false;
                        if (this.pmsProjectType === 1) {
                            btnText = "一次性国产报价审核通过";
                        } else {
                            btnText = "国产报价审核通过";
                        }
                    } else
                        // 生效
                        if (this.dqState === TechnologyQuotationStatus.Completed) {
                            isClickable = isClickable && false;
                            if (this.pmsProjectType === 1) {
                                btnText = "一次性国产报价已生效";
                            } else {
                                btnText = "国产报价已生效";
                            }
                        }
                        else
                            // 禁用
                            if (this.dqState === TechnologyQuotationStatus.Disable) {
                                isClickable = isClickable && false;
                                if (this.pmsProjectType === 1) {
                                    btnText = "一次性国产报价已禁用";
                                } else {
                                    btnText = "国产报价已禁用";
                                }
                            }
        if (!isGranted("Role.GCS") && !isGranted("Role.SuperGCS")) {
            isShow = isShow && false;
        }
        if (this.inventoryDqHasIssue) {
            isShow = isShow && true;
        } else {
            isShow = isShow && false;
        }

        this.dqBtnState.isShow = isShow && this.globalBtnState;
        this.dqBtnState.isClickable = isClickable;
        this.dqBtnState.btnText = btnText;
    }

    //更新状态
    stateUpdate = (includeStepUpdate = true) => {
        this.prevStateUpdate();
        this.nextStateUpdate();
        this.completeStateUpdate();
        this.needHelpbtnStateUpdate();
        this.teStateUpdate();
        this.dqStateUpdate();
        this.gcsCompleteBtnStateUpdate();
    }

    @action
    setInvHasIssue = (isHasIssue: boolean) => {
        this.inventoryHasIssue = isHasIssue;
        // this.stateUpdate();
        this.completeStateUpdate();
        this.gcsCompleteBtnStateUpdate()
        this.nextStateUpdate();
    }

    @action
    setInvDqHasIssue = (inventoryDqHasIssue: boolean) => {
        this.inventoryDqHasIssue = inventoryDqHasIssue;
        this.dqStateUpdate();
    }

    @action
    setInvTeHasIssue = (inventoryTeHasIssue: boolean) => {
        this.inventoryTeHasIssue = inventoryTeHasIssue;
        this.teStateUpdate();
    }

    //设置当前步骤
    @action
    setcurrentStep = (_currentStep: number) => {
        if (_currentStep >= 4) {
            this.currentStep = 4;
        } else {
            this.currentStep = _currentStep;
        }
        this.prevStateUpdate();
        // 面价未完全加载完,隐藏下一步按钮
        if (this.currentStep != InvotorySteps.ListPriceMatching) {
            this.nextStateUpdate();
        }
        this.needHelpbtnStateUpdate();
        // this.stateUpdate();
    }

    //设置选型状态
    @action
    setInvState = (_invState?: LectoTypeStatus) => {
        this.invState = _invState;
        this.stateUpdate();
    }

    //设置技术协议状态
    @action
    setTeState = (_teState?: TechnologyQuotationStatus) => {
        this.teState = _teState;
        this.stateUpdate();
    }
    //设置境界选型状态
    @action
    setJinLectoType = (_jinLectoType?: boolean) => {
        this.jinLectoType = _jinLectoType;
        this.stateUpdate();
    }
    //设置一次性项目状态
    @action
    setPMSType = (_pmsProjectType?: number) => {
        this.pmsProjectType = _pmsProjectType;
        this.stateUpdate();
    }
    //设置一次性项目国产报价状态
    @action
    setPMSDqState = (_PMSDqState?: boolean) => {
        this.pmsDqState = _PMSDqState;
        this.stateUpdate();
    }
    //设置国产报价状态
    @action
    setDqState = (_dqState?: TechnologyQuotationStatus) => {
        this.dqState = _dqState;
        this.stateUpdate();
    }


    //设置客户号
    @action
    setInvClientId = (_clientId?: string, _saleId?: string) => {
        this.invClientId = _clientId;
        this.saleId = _saleId;
        this.stateUpdate();
    }

    //设置国产报价，技术协议，选型状态
    @action
    setAllInvState = (_dqState?: TechnologyQuotationStatus, _teState?: TechnologyQuotationStatus, _invState?: LectoTypeStatus, _clientId?: string) => {
        this.invState = _invState;
        this.teState = _teState;
        this.dqState = _dqState;
        this.invClientId = _clientId;
        this.stateUpdate();
    }

    // 禁用所有按钮
    // 页面加载时调用
    @action
    disableALLBtn = () => {
        this.globalBtnState = false;
        this.stateUpdate(false);
    }

    // 恢复按钮状态
    // 数据加载完成后恢复
    @action
    enableALLBtn = () => {
        this.globalBtnState = true;
        this.stateUpdate(false);
    }

    // 恢复按钮状态
    // 数据加载完成后恢复
    @action
    setNextState = (isShow: boolean) => {
        this.nextBtnState.isShow = isShow;
    }
}

export default InventoryStatusStore;